import { fetchRequestWithToken } from '@/config/axios';
import Logger from '@/config/Logger';
import { creditStore } from '@/state/CriditStore';

export const useCredits = () => {
  const getCreditHistory = async (_id: string) => {
    creditStore.setLoading(true);
    try {
      const response = await fetchRequestWithToken({
        url: `/credits-history/workspace/${_id}`,
        method: 'GET',
      });
      creditStore.setCredits(response?.data?.data);
    } catch (error) {
      Logger.error("Error in 'getCreditHistory':", error);
    } finally {
      creditStore.setLoading(false);
    }
  };
  return {
    getCreditHistory,
  };
};
